module.exports = __webpack_public_path__ + "static/media/IMG_7621-min.cdc53f3b.jpg";